import React from 'react';
import replaceCssClasses from '@src/js/Style';
import Card from './Card';
import View from '../Designer/View';
import Text from '../Designer/Text';
import Collection from '../Designer/Collection';
import Link from '../Designer/Link';

export default class TimelineSingle extends View {

    renderContent() {

        return (
            <View>

                <Text
                    role='title'
                    placeholder='Steps block title'
                    className='title2 w-full mb-6'
                    style={{ minHeight: '36px' }} />

                <Collection
                    role='steps'
                    placeholder='Steps'
                    className='mt-4 flex flex-wrap timeline timeline--nodates'
                    schema='howto'
                    children={ this.renderStep() } />

            </View>
        );
    }

    renderStep() {

        return (
            <View className='timeline__item'>
                <View className='timeline__text'>
                    <Card className={ replaceCssClasses('w-full') }>
                        <View className='flex flex-wrap gap'>

                            <View className='w-full flex justify-between gap items-start'>
                                <Text role='title' placeholder='Title' className='title3' />
                                <Text role='step' placeholder='Step text' className='badge-success-opacity badge-sm rounded-full' />
                            </View>

                            <Text role='text' placeholder='Text' unsafe={ true } className='w-full' />

                            <Link
                                role='buttonText'
                                placeholder='Button'
                                className='button hidden-when-empty mb-4'
                                target='_blank'
                                href={ <Text role='link' placeholder='Button link' /> } />

                        </View>
                    </Card>
                </View>
            </View>
        );
    }

}